import {
  GoabModal,
  GoabButtonGroup,
  GoabButton,
  GoabText,
} from "@abgov/react-components";
import { useSessionManagement } from "../../ServiceUtils/useSessionManagement";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

interface SignoutModalProps {
  showModal?: boolean;
}

const MODAL_TEST_ID = "logout--modal";

export const SignoutModal = ({ showModal }: SignoutModalProps) => {
  const [show, setShow] = useState<boolean>(showModal ?? false);
  const { getResourceValue } = useSessionManagement();
  const navigate = useNavigate();

  // The modal's focus trap focuses its scrollable content region on open, which paints a
  // focus outline around the message. Redirect that initial focus to the primary action.
  useEffect(() => {
    if (!show) return;

    const modal = document.querySelector(`goa-modal[testid="${MODAL_TEST_ID}"]`);
    if (!modal) return;

    const redirectInitialFocus = () => {
      modal.removeEventListener("focusin", redirectInitialFocus);
      modal
        .querySelector("goa-button")
        ?.shadowRoot?.querySelector("button")
        ?.focus();
    };

    modal.addEventListener("focusin", redirectInitialFocus);
    return () => modal.removeEventListener("focusin", redirectInitialFocus);
  }, [show]);

  return (
    <GoabModal
      testId={MODAL_TEST_ID}
      calloutVariant="success"
      open={show}
      maxWidth="480px"
      heading="Signed out"
      actions={
        <GoabButtonGroup alignment="end">
          <GoabButton
            type="primary"
            testId="logout-okay-button"
            onClick={() => {
              setShow(false);
              navigate("/");
            }}
          >
            {getResourceValue({ key: "RESOURCES@global.okay" })}
          </GoabButton>
        </GoabButtonGroup>
      }
    >
      <GoabText mb="none" mt="none">
        {getResourceValue({ key: "RESOURCES@global.logoutmessage" })}
      </GoabText>
    </GoabModal>
  );
};
